/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DashboardTrendBucketDTO } from './dashboard-trend-bucket-dto';
import { DashboardTempoRispostaDTO } from './dashboard-tempo-risposta-dto';


export interface DashboardTrendDTO { 
    granularita?: string;
    serie?: Array<DashboardTrendBucketDTO>;
    tempo_risposta?: DashboardTempoRispostaDTO;
}

